namespace TabAurous.Production {
    export interface WIPTransactionForm {
        TransId: Serenity.StringEditor;
        RefTransId: Serenity.StringEditor;
        VoucherDate: Serenity.DateEditor;
        VoucherTypeId: Serenity.IntegerEditor;
        VoucherNo: Serenity.StringEditor;
        RefVoucherId: Serenity.IntegerEditor;
        DepartmentId: Serenity.IntegerEditor;
        PartyId: Serenity.IntegerEditor;
        Line_No: Serenity.StringEditor;
        BagNo: Serenity.StringEditor;
        SKU: Serenity.StringEditor;
        LotNo: Serenity.StringEditor;
        CertificateNo: Serenity.StringEditor;
        RefNo: Serenity.StringEditor;
        GroupId: Serenity.StringEditor;
        ItemTypeId: Serenity.IntegerEditor;
        HSN: Serenity.StringEditor;
        ProductId: Serenity.StringEditor;
        AttributeId: Serenity.StringEditor;
        StoneStatusId: Serenity.LookupEditor;
        Studded: Serenity.IntegerEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        NetWeight: Serenity.DecimalEditor;
        DiamondPieces: Serenity.IntegerEditor;
        DiamondWeight: Serenity.DecimalEditor;
        StonePieces: Serenity.IntegerEditor;
        StoneWeight: Serenity.DecimalEditor;
        OtherPieces: Serenity.IntegerEditor;
        Rate: Serenity.DecimalEditor;
        OtherWeight: Serenity.DecimalEditor;
        MetalAmount: Serenity.DecimalEditor;
        DiamondAmount: Serenity.DecimalEditor;
        StoneAmount: Serenity.DecimalEditor;
        OtherAmount: Serenity.DecimalEditor;
        CalcOnId: Serenity.IntegerEditor;
        CostMethodId: Serenity.LookupEditor;
        ImageName: Serenity.StringEditor;
        CompanyId: Serenity.IntegerEditor;
        FinancialYearId: Serenity.IntegerEditor;
        Purity: Serenity.DecimalEditor;
        PureWeight: Serenity.DecimalEditor;
    }

    export class WIPTransactionForm extends Serenity.PrefixedContext {
        static formKey = 'Production.WIPTransaction';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!WIPTransactionForm.init)  {
                WIPTransactionForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.DateEditor;
                var w2 = s.IntegerEditor;
                var w3 = s.LookupEditor;
                var w4 = s.DecimalEditor;

                Q.initFormType(WIPTransactionForm, [
                    'TransId', w0,
                    'RefTransId', w0,
                    'VoucherDate', w1,
                    'VoucherTypeId', w2,
                    'VoucherNo', w0,
                    'RefVoucherId', w2,
                    'DepartmentId', w2,
                    'PartyId', w2,
                    'Line_No', w0,
                    'BagNo', w0,
                    'SKU', w0,
                    'LotNo', w0,
                    'CertificateNo', w0,
                    'RefNo', w0,
                    'GroupId', w0,
                    'ItemTypeId', w2,
                    'HSN', w0,
                    'ProductId', w0,
                    'AttributeId', w0,
                    'StoneStatusId', w3,
                    'Studded', w2,
                    'Pieces', w2,
                    'Weight', w4,
                    'NetWeight', w4,
                    'DiamondPieces', w2,
                    'DiamondWeight', w4,
                    'StonePieces', w2,
                    'StoneWeight', w4,
                    'OtherPieces', w2,
                    'Rate', w4,
                    'OtherWeight', w4,
                    'MetalAmount', w4,
                    'DiamondAmount', w4,
                    'StoneAmount', w4,
                    'OtherAmount', w4,
                    'CalcOnId', w2,
                    'CostMethodId', w3,
                    'ImageName', w0,
                    'CompanyId', w2,
                    'FinancialYearId', w2,
                    'Purity', w4,
                    'PureWeight', w4
                ]);
            }
        }
    }
}
